import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=5c06cade"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c06cade')) {
      api.createRecord('5c06cade', component.options)
    } else {
      api.reload('5c06cade', component.options)
    }
    module.hot.accept("./NewPassword.vue?vue&type=template&id=5c06cade", function () {
      api.rerender('5c06cade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewPassword.vue"
export default component.exports